import {createReducer, on, Action} from '@ngrx/store';

import * as ProofOfDeliveryActions from './proof-of-delivery.actions';
import {Portals} from '@qwyk/models';

export const PROOF_OF_DELIVERY_FEATURE_KEY = 'proofOfDelivery';

export interface State {
    loading: boolean; // has the ProofOfDelivery list been loading
    error?: string | null; // last known error (if any)
    proofOfDelivery?: Portals.ProofOfDelivery | null;
    hasOne: boolean;
}

export interface ProofOfDeliveryPartialState {
    readonly [PROOF_OF_DELIVERY_FEATURE_KEY]: State;
}


export const initialState: State = {
    loading: false,
    hasOne: false
};

const proofOfDeliveryReducer = createReducer(
    initialState,
    on(ProofOfDeliveryActions.init, state => ({
        ...state,
        loading: false,
        error: null,
    })),
    on(
        ProofOfDeliveryActions.loadProofOfDeliverySuccess,
        (state, {proofOfDelivery}) => ({
            ...state,
            proofOfDelivery,
            hasOne: true
        })
    ),
    on(
        ProofOfDeliveryActions.loadProofOfDeliveryFailure,
        (state, {error}) => ({...state, error, hasOne: false})
    ),
    on(
        ProofOfDeliveryActions.reset, (() => initialState)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return proofOfDeliveryReducer(state, action);
}
